module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.mod === 'default' && !_vm.backArrow) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    ref: "search-input",
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme],
    style: ({
      width: _vm._px2rem(_vm.inputWidth ? _vm.inputWidth + 'px' : _vm.showRightContent ? _vm.themeStyle.inputWidth : '686px', 75)
    }),
    attrs: {
      "return-key-type": _vm.returnKeyType,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "data-evt-blur": "",
      "data-evt-focus": "",
      "data-evt-input": "",
      "data-evt-return": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      },
      "focus": function($event) {
        $event.stopPropagation();
        return _vm.onFocus($event)
      },
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "return": function($event) {
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "disabled-input weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.inputDisabledClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm._theme != 'colmo') ? _c('figure', {
    staticClass: "search-bar-icon weex-el weex-image",
    attrs: {
      "aria-hidden": true,
      "src": _vm.inputIcon,
      "data-img-src": _vm.inputIcon,
      "weex-type": "image"
    }
  }) : (_vm._theme == 'colmo') ? _c('div', {
    staticClass: "search-bar-icon weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('dof-iconfont', {
    attrs: {
      "size": "64",
      "code": '\u4785',
      "color": "#71717A"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showClose && _vm._theme != 'colmo') ? _c('figure', {
    staticClass: "search-bar-close weex-el weex-image",
    style: ({
      right: _vm._px2rem(_vm.showRightContent ? '144px' : '48px', 75)
    }),
    attrs: {
      "aria-hidden": true,
      "src": _vm.closeIcon,
      "data-img-src": _vm.closeIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeClicked($event)
      }
    }
  }) : (_vm.showClose && _vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: "search-bar-close",
    style: ({
      right: _vm._px2rem(_vm.showRightContent ? '144px' : '48px', 75)
    }),
    attrs: {
      "size": "48",
      "code": '\u4725',
      "color": "#71717A",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.closeClicked
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("rightContent", [(_vm.showRightContent) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: (_vm._processExclusiveStyle(_vm.buttonStyle, 75, 'text')),
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()], {})], 2) : _vm._e(), _vm._v(" "), (_vm.mod === 'default' && _vm.backArrow) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._theme != 'colmo') ? _c('figure', {
    staticClass: "search-bar-arrow-base weex-el weex-image",
    attrs: {
      "src": (_vm.theme == 'black' || _vm._isDiablo) ? _vm.W_backArrowIcon : _vm.B_backArrowIcon,
      "data-img-src": (_vm.theme == 'black' || _vm._isDiablo) ? _vm.W_backArrowIcon : _vm.B_backArrowIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.backArrowClicked($event)
      }
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: "search-bar-arrow",
    attrs: {
      "size": "64",
      "code": '\u4717',
      "color": "rgba(255,255,255,0.80)",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.backArrowClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "search-input",
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme, 'search-bar-input-arrow-colmo'],
    style: ({
      width: _vm._px2rem(_vm.inputWidth ? _vm.inputWidth + 'px' : _vm.showRightContent && _vm.backArrow ? _vm.themeStyle.inputwithBackArrow : '610px', 75),
      marginLeft: _vm._px2rem(_vm.themeStyle.inputwithBackArrowLeft, 75)
    }),
    attrs: {
      "return-key-type": _vm.returnKeyType,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "data-evt-blur": "",
      "data-evt-focus": "",
      "data-evt-input": "",
      "data-evt-return": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      },
      "focus": function($event) {
        $event.stopPropagation();
        return _vm.onFocus($event)
      },
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "return": function($event) {
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "disabled-input weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.inputDisabledClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm._theme != 'colmo') ? _c('figure', {
    staticClass: " weex-el weex-image",
    class: ['search-bar-icon', _vm.backArrow && 'search-bar-icon-hasArrow'],
    attrs: {
      "aria-hidden": true,
      "src": _vm.inputIcon,
      "data-img-src": _vm.inputIcon,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showClose && _vm._theme != 'colmo') ? _c('figure', {
    staticClass: "search-bar-close weex-el weex-image",
    style: ({
      right: _vm._px2rem(_vm.showRightContent && _vm.backArrow ? '136px' : '48px', 75)
    }),
    attrs: {
      "aria-hidden": true,
      "src": _vm.closeIcon,
      "data-img-src": _vm.closeIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeClicked($event)
      }
    }
  }) : (_vm.showClose && _vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: "search-bar-close",
    style: ({
      right: _vm._px2rem(_vm.showRightContent ? '136px' : '48px', 75)
    }),
    attrs: {
      "size": "48",
      "code": '\u4725',
      "color": "#71717A",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.closeClicked
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("rightContent", [(_vm.showRightContent) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: (_vm._processExclusiveStyle(_vm.buttonStyle, 75, 'text')),
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()], {})], 2) : _vm._e(), _vm._v(" "), (_vm.mod === 'hasSelect') ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme],
    style: ({
      width: _vm._px2rem(_vm.inputWidth ? _vm.inputWidth + 'px' : _vm.showRightContent ? '590px' : '590px', 75),
      paddingRight: _vm._px2rem('150px', 75)
    }),
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "return-key-type": _vm.returnKeyType,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "data-evt-blur": "",
      "data-evt-focus": "",
      "data-evt-input": "",
      "data-evt-return": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      },
      "focus": function($event) {
        $event.stopPropagation();
        return _vm.onFocus($event)
      },
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "return": function($event) {
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "disabled-input has-dep-disabled weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.inputDisabledClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['bar-dep', '.bar-dep-' + _vm.theme],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    ref: "selectedText",
    staticClass: " weex-el weex-text",
    class: ['selected-text', 'selected-text-' + _vm.theme],
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.showSelectList($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedText))]), _vm._v(" "), (_vm.selectList) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['selectBlock', 'selectBlock-' + _vm.theme],
    style: (_vm._px2rem(_vm.selectBlockStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('p', {
      key: item,
      staticClass: " weex-el weex-text",
      class: ['select-text', 'select-text-' + _vm.theme],
      attrs: {
        "weex-type": "text",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.selectItem(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e(), _vm._v(" "), _c('figure', {
    staticClass: "dep-arrow weex-el weex-image",
    attrs: {
      "src": _vm.arrowIcon,
      "aria-hidden": true,
      "data-img-src": _vm.arrowIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.showSelectList($event)
      }
    }
  })]), _vm._v(" "), _c('figure', {
    staticClass: "search-bar-icon weex-el weex-image",
    attrs: {
      "aria-hidden": true,
      "src": _vm.inputIcon,
      "data-img-src": _vm.inputIcon,
      "weex-type": "image"
    }
  }), _vm._v(" "), _vm._t("rightContent", [(_vm.showRightContent) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: (_vm._processExclusiveStyle(_vm.buttonStyle, 75, 'text')),
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()], {})], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dfad134", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dfad134","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-searchbar/index.vue
// module id = 619
// module chunks = 0 1